<script>
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";

export default {
    name: "ProductSelfPickupInfo",
    components: {TextAccordion}
}
</script>

<template>
    <div class="p-5 border border-gray-200 shadow-sm bg-[#d1ecf1] rounded-lg">
        <div class="text-base font-bold text-black mb-5">
            Как забрать самовывозом
        </div>
        <TextAccordion :minHeight="75">
            <ul class="max-w-md space-y-4 list-disc list-outside text-white text-base md:text-xl ms-6">
                <li class="text-xs text-black font-medium">
                    В ФУЛЛ СТРОЙ можно забрать заказ самовывозом со склада. Это удобно, если у вас свой транспорт или
                    нужно быстрее получить материалы без ожидания доставки.
                </li>
                <li class="text-xs text-black font-medium">
                    Сначала оформите заказ на сайте или через менеджера - укажите нужные позиции, объем и характеристики.
                    После этого вам подтвердят наличие и подготовят заказ к отгрузке.
                </li>
                <li class="text-xs text-black font-medium">
                    После подтверждения согласуйте время приезда. Это важно, чтобы мы заранее подготовили материалы и
                    не было простоев при загрузке.
                </li>
                <li class="text-xs text-black font-medium">
                    В назначенное время приезжайте на склад. Сотрудники помогут с погрузкой ЖБИ, пиломатериалов,
                    тротуарной плитки, нерудных материалов или других позиций, чтобы все было безопасно размещено в
                    транспорте.
                </li>
            </ul>
        </TextAccordion>
    </div>
</template>

<style scoped lang="scss">

</style>
